<template>
  <main class="mode-page">
    <header class="top">
      <div class="top-glow"></div>
      <div class="tabs">
        <span class="tab" @click="$router.push({name:'device',query:{iccid:imei}})">联网模式</span>
        <span class="tab active">本地模式</span>
      </div>
    </header>
    <section class="status-card card">
      <div class="status-item"><img src="./static/images/service-mode/Frame.png" alt=""><span>设备连接 {{ deviceInfo.client_number || 0 }}</span></div>
      <div class="status-item"><img src="./static/images/service-mode/Frame-2.png" alt=""><span>{{ online === 1 ? "在线" : "离线" }}</span></div>
    </section>
    <section class="block">
      <h2>设备设置</h2>
      <div class="card setting-card">
        <div class="row row-input"><span>WiFi名称：</span><input class="wifi-input" type="text" v-model="editSsid.ssid" :placeholder="deviceInfo.ssid"></div>
        <div class="row row-input"><span>WiFi密码：</span><input class="wifi-input" type="text" v-model="editSsid.key" :placeholder="deviceInfo.password"><button @click="saveSsid">保存</button></div>
        <div class="row"><span>设备重启</span><button @click="restart">重启</button></div>
        <div class="row"><span>设备恢复出厂设置</span><button @click="reset">重置</button></div>
      </div>
    </section>
    <section class="block">
      <h2>网络切换</h2>
      <div class="card net-card">
        <button class="net-btn" :class="{active:deviceInfo.current_sim_id===0}" @click="qieka(0)">中国电信</button>
        <button class="net-btn" :class="{active:deviceInfo.current_sim_id===1}" @click="qieka(1)">中国联通</button>
        <button class="net-btn" :class="{active:deviceInfo.current_sim_id===2}" @click="qieka(2)" v-if="deviceInfo.sim_list && deviceInfo.sim_list[2]">中国移动</button>
        <button class="net-btn" @click="qieka(99)">智能选网</button>
      </div>
    </section>
    <section class="block">
      <h2>设备信息</h2>
      <div class="card info-card">
        <div class="row"><span>卡号：</span><span>{{ deviceInfo.iccid }}</span></div>
        <div class="row"><span>信号强度：</span><span>{{ deviceInfo.rsrp }}dbm 良好</span></div>
        <div class="row"><span>imei码：</span><span>{{ deviceInfo.imei }}</span></div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from "axios"
const http = axios.create({ baseURL: "http://192.168.0.1/notion_web_api", timeout: 3000, headers: { "content-type": "application/json" } })

export default {
  name: "devicelocalNew",
  data () { return { imei: "", deviceInfo: {}, editSsid: { ssid: "", key: "" }, online: 0 } },
  methods: {
    retryDialog (fn) {
      this.$dialog.confirm({ title: "连接失败", message: "请使用本机连接设备WiFi后，点击下方重试按钮", confirmButtonText: "已连接，重试" }).then(fn)
    },
    getDeviceInfo () {
      this.$toast.loading({ duration: 0 })
      http.post("", {}, { data: { action: "101" } }).then((res) => {
        this.$toast.clear()
        this.deviceInfo = Object.assign(this.deviceInfo, res.data.device_info)
        this.online = 1
      }).catch(() => { this.$toast.clear(); this.retryDialog(this.getDeviceInfo) })
    },
    getWifiInfo () {
      this.$toast.loading({ duration: 0 })
      http.post("", {}, { data: { action: "102" } }).then((res) => {
        this.$toast.clear()
        this.deviceInfo = Object.assign(this.deviceInfo, res.data.wifi)
      }).catch(() => { this.$toast.clear(); this.retryDialog(this.getWifiInfo) })
    },
    getSimInfo () {
      this.$toast.loading({ duration: 0 })
      http.post("", {}, { data: { action: "103" } }).then((res) => {
        this.$toast.clear()
        this.deviceInfo = Object.assign(this.deviceInfo, res.data.multi_sim)
      }).catch(() => { this.$toast.clear(); this.retryDialog(this.getSimInfo) })
    },
    restart () {
      http.post("", {}, { data: { action: "001" } }).then((res) => {
        this.$toast(res.data && res.data.error_code === "0" ? "发送成功" : res.data.error_code)
      }).catch(() => this.retryDialog(this.restart))
    },
    reset () {
      this.$dialog.confirm({ title: "提示", message: "确认将设备恢复到出厂状态？" }).then(() => {
        http.post("", {}, { data: { action: "002" } }).then((res) => {
          this.$toast(res.data && res.data.error_code === "0" ? "发送成功" : res.data.error_code)
        }).catch(() => this.retryDialog(this.reset))
      })
    },
    saveSsid () {
      if (!this.editSsid.ssid || !this.editSsid.key) return this.$toast("请输入WiFi名称和密码")
      this.$toast.loading({ message: "设置中", forbidClick: true })
      http.post("", {}, { data: { action: "201", wifi: { ssid: this.editSsid.ssid, password: this.editSsid.key } } }).then((res) => {
        this.$toast.clear()
        this.$toast(res.data && res.data.error_code === "0" ? "设置成功" : res.data.error_code)
      }).catch(() => { this.$toast.clear(); this.retryDialog(this.saveSsid) })
    },
    qieka (index) {
      if (index === this.deviceInfo.current_sim_id) return
      this.$toast.loading({ message: "设置中", forbidClick: true })
      http.post("", {}, { data: { action: "202", switch_mode: "0", sim_id: `${index}` } }).then((res) => {
        this.$toast.clear()
        if (res.data && res.data.error_code === "0") {
          this.deviceInfo.current_sim_id = index
          this.$toast("设置成功")
        } else {
          this.$toast(res.data.error_code)
        }
      }).catch(() => { this.$toast.clear(); this.retryDialog(() => this.qieka(index)) })
    }
  },
  created () {
    this.imei = this.$route.query.iccid
    this.getDeviceInfo()
    this.getWifiInfo()
    this.getSimInfo()
  }
}
</script>

<style scoped src="./static/css/service-mode-a.css"></style>



// WEBPACK FOOTER //
// src/newpage/devicelocal.vue